import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import useToast from '../../useToast';
import { useParams } from 'react-router';
import { API_CASINO } from '../../../api/casino';

export default function useCreateCasinoController({ onSaveClick }) {
  const { errorToast } = useToast();

  const { casinoId } = useParams();

  const languages = useAppSelector((state) => state.info.casinoLanguages);
  const [domains, setDomains] = useState([]);
  const [defaultLanguage, setDefaultLanguage] = useState(1);
  const [languageFields, setLanguageFields] = useState({ en: { enabled: true } });
  const [casinoName, setCasinoName] = useState('');
  const [selectGroupId, setSelectGroupId] = useState('');
  const [selectCurrencies, setSelectCurrencies] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);

  // получение параметров о казино, если нет казино ИД, то создаётся новое
  useEffect(() => {
    if (!casinoId) return;

    API_CASINO.get
      .props({ casinoId })
      .then((e) => {
        const info = e.data.info;
        setCasinoName(info.name);
        setSelectCurrencies(info.currencyList);
        setSelectGroupId(info.groupId);
        setDomains(info.domainList);
        setLanguageFields(info.langList);
        const langs = Object.keys(info.langList);
        const defaultLang = langs.find((lang) => info.langList[lang].default);
        const langValue = languages.find((el) => el.lang == defaultLang).value;
        setDefaultLanguage(langValue);
      })
      .catch(console.error);
  }, [casinoId]);

  useEffect(() => {
    setBtnDisabled(false);
  }, []);

  const selectDomain = domains.find((el) => el.default);

  const saveDomains = (list) => {
    setDomains(list);
  };

  const changeLanguages = (name, val, lang) => {
    setLanguageFields((prev) => {
      const prevInfo = JSON.parse(JSON.stringify(prev));
      if (!prevInfo[lang]) prevInfo[lang] = {};
      prevInfo[lang][name] = val;

      return prevInfo;
    });
  };

  const saveCasino = async () => {
    if (!casinoName) {
      errorToast('Casino name is required');
      return;
    }
    if (!selectGroupId) {
      errorToast('Default group required');
      return;
    }
    if (!domains.length) {
      errorToast('Default domain required');
      return;
    }

    setBtnDisabled(true);

    const domainList = domains.map((el) => ({ name: el.name, default: el.default }));
    const langList = {};

    for (let lang in languageFields) {
      const field = languageFields[lang];
      if (!field.enabled) continue;
      if (!langList[lang]) langList[lang] = {};
      langList[lang].default = field.default || false;
      langList[lang].channelLink = field.channelLink || '';
      langList[lang].chatLink = field.chatLink || '';
      langList[lang].postLink = field.postLink || '';
      langList[lang].reviewLink = field.reviewLink || '';
      langList[lang].supportChat = field.supportChat || '';
      langList[lang].supportEmail = field.supportEmail || '';
    }

    const choseLang = languages?.find((el) => el.value == defaultLanguage)?.lang;

    if (!langList[choseLang]) langList[choseLang] = {};
    langList[choseLang].default = true;

    const data = {
      name: casinoName,
      groupId: selectGroupId,
      currencyList: selectCurrencies,
      domainList: domainList,
      langList: langList
    };

    if (casinoId) data.casinoId = casinoId;
    await onSaveClick(data);

    setBtnDisabled(false);
  };

  return {
    domains,
    selectDomain,
    languages,
    defaultLanguage,
    languageFields,
    casinoName,
    selectGroupId,
    selectCurrencies,
    btnDisabled,
    saveCasino,
    setCasinoName,
    setSelectGroupId,
    setSelectCurrencies,
    setDefaultLanguage,
    changeLanguages,
    setDomains,
    saveDomains
  };
}
